"use client";
import LoadingDots from "../../Atoms/LoadingDots";
import { LIMITED_STOCK_MESSAGE } from "../../../public/Constants/EnumConstants";
import { addToCartRest } from "../../../lib/bigcommerce/restfull/apis/cartAPIS";
import { UPDATE_CART_SUCCESSFULLY } from "../../../public/Constants/EnumConstants";
import { EcommCart } from "../../../public/Theme";
import { sendGTMEvent } from "@next/third-parties/google";
import clsx from "clsx";
import Image from "next/image";
import { useEffect, useState } from "react";
import { useFormState, useFormStatus } from "react-dom";
import { toast } from "react-toastify";
import useStore from "../../../lib/Store/useStore";

function SubmitButton({ availableForSale, selectedVariantId }) {
    const { pending } = useFormStatus();
    const isProduction = process?.env?.NEXT_PUBLIC_ENV === "production";

    const buttonClasses =
        "flex items-center justify-center gap-2 text-center min-w-[210px] bg-New_Primary_Default hover:bg-New_Primary_Hover active:bg-New_Primary_Pressed hover:border-New_Primary_Hover active:border-New_Primary_Pressed focus:outline-none md:w-52  rounded-sm	py-2.5 px-4 mt-8 text-sm sm:text-base font-bold gap-2.5 text-Text_White w-full";
    const disabledClasses =
        "pointer-events-none cursor-not-allowed opacity-60 hover:opacity-60";

    if (!availableForSale) {
        return (
            <button
                aria-disabled
                className={clsx(buttonClasses, disabledClasses)}
            >
                Out Of Stock
            </button>
        );
    }

    if (!selectedVariantId) {
        return (
            <button
                aria-label="Please select an option"
                aria-disabled
                disabled={true}
                className={clsx(buttonClasses, disabledClasses)}
            >
                Add To Cart
            </button>
        );
    }

    return (
        <button
            onClick={(e) => {
                if (pending) e.preventDefault();
                if (isProduction) {
                    window?.fbq("track", "AddToCart", {
                        content_ids: [selectedVariantId], // 'REQUIRED': array of product IDs
                        content_type: "product", // RECOMMENDED: Either product or product_group based on the content_ids or contents being passed.
                    });
                }
            }}
            aria-label="Add to cart"
            aria-disabled={pending}
            className={clsx(buttonClasses, {
                "hover:opacity-90": true,
                disabledClasses: pending,
            })}
        >
            Add To Cart
            <div className="">
                {pending ? (
                    <LoadingDots className="mb-2 bg-white" />
                ) : (
                    <Image
                        src={EcommCart}
                        alt={"cart icon"}
                        width={0}
                        height={0}
                        className="h-auto w-auto"
                    />
                )}
            </div>
        </button>
    );
}

const QuickAddToCart = ({
    selectedVariantData,
    availableForSale,
    productName,
    quantity,
}) => {
    const { updateCartData, cartId, currency } = useStore();

    const [selectedVariant, setSelectedVariant] = useState(selectedVariantData);
    const variant = selectedVariant;
    useEffect(() => {
        if (selectedVariantData) setSelectedVariant(selectedVariantData);
    }, [selectedVariantData]);

    const [message, formAction] = useFormState(async (useLess, item) => {
        try {
            const response = await addToCartRest(item, cartId, currency);
            sendGTMEvent({
                event: "CartAndCheckoutInteractions",
                interaction_type: "ItemQuickAddToCart",
                interaction_item: `ProductName: ${productName}, variant: ${variant}`,
            });
            if (!(response?.status == 422)) {
                updateCartData(response);
                toast(UPDATE_CART_SUCCESSFULLY, {
                    type: "success",
                    toastId: UPDATE_CART_SUCCESSFULLY,
                });
            } else if (res?.status === 404) {
                toast("Cart Does not Exist", {
                    type: "error",
                    toastId: "Cart Does not Exist",
                });
            } else {
                toast(LIMITED_STOCK_MESSAGE, {
                    type: "error",
                    toastId: LIMITED_STOCK_MESSAGE,
                });
            }
        } catch (error) {
            toast(error, {
                type: "error",
                toastId: LIMITED_STOCK_MESSAGE,
            });
            console.error("Failed to add item:", error);
        }
    }, null);

    const productQuantity = quantity || 1;
    const actionWithVariant = formAction.bind(null, {
        selectedProductId:
            selectedVariant?.parentId || selectedVariant?.product_id,
        selectedVariantId: selectedVariant?.id || selectedVariant?.variant_id,
        quantity: productQuantity,
    });
    useEffect(() => {
        message &&
            toast(LIMITED_STOCK_MESSAGE, {
                type: "error",
                toastId: LIMITED_STOCK_MESSAGE,
            });
    }, [message]);
    return (
        <form action={actionWithVariant}>
            <SubmitButton
                availableForSale={availableForSale}
                selectedVariantId={selectedVariant?.id}
            />
            <p aria-live="polite" className="sr-only" role="status">
                {message}
            </p>
        </form>
    );
};
export default QuickAddToCart;
